import styled from 'styled-components';

export const InvestorDetailsCardStyles = styled.div`
	overflow: hidden;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.5rem;
	background: ${({ theme }) => theme.v3.colors.white[0]};

	> .header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 0.5rem;
		min-height: 3rem;
		padding: 0.5rem 1rem;
	}

	> .content > .content-inner {
		border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		padding: 0.5rem;
	}

	.count {
		display: flex;
		justify-content: center;
		align-items: center;
		min-width: 1.5rem;
		height: 1.5rem;
		border-radius: 50%;
		background: ${({ theme }) => theme.v3.colors.gray[4]};
	}
`;
